module.exports = __webpack_public_path__ + "static/media/order.563a75c3.svg";